import  request  from '../../Interceptor/request.js'

//根据单号查询具体内容
export function numberSel(data) {
    return request({
        url: '/order/list',
        method: 'get',
        params:data
    })
}

//用量记录查询
export function usage(data){
    return request({
        url: '/eleBillDay/betweenTime',
        method: 'get',
        params:data
    })
}


//日月用电量查询
export function dayMon(data){
    return request({
        url: '/eleBillMonth/betweenTime',
        method: 'get',
        params:data
    })
}